import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    opponent: {},
    opponentScore: 0,
    opponentCorrectAnswer: 0,
    opponentWrongAnswer: 0,
};

const opponentPlayerSlice = createSlice({
    name: "opponentPlayerSlice",
    initialState,
    reducers: {
        setOpponent: (state, action) => {
            state.opponent = action.payload;
            return state;
        },
        opponentScoreUpdate: (state, action) => {
            const random = Math.floor(Math.random() * (2 - 0)) + 0;
            console.log(random);
            if (random === 1) {
                state.opponentScore = state.opponentScore + action.payload;
                state.opponentCorrectAnswer = state.opponentCorrectAnswer + 1;
            } else {
                state.opponentWrongAnswer = state.opponentWrongAnswer + 1;
            }
            return state;
        },
        resetOpponentScore: (state, action) => {
            state.opponentScore = 0;
            state.opponentCorrectAnswer = 0;
            state.opponentWrongAnswer = 0;
            return state;
        },
    },
});
export const {
    setOpponent,
    resetOpponentScore,
    opponentScoreUpdate,
} = opponentPlayerSlice.actions;
export default opponentPlayerSlice;